export const isParticipantCheckInStaffViewRequest = (requestUrl: string): boolean =>
  /\/classes\/[^/?#]+\/participants\/[^/?#]+\/check-in(?:\?[^#]*)?$/.test(requestUrl);
